document.addEventListener("DOMContentLoaded", () => {
  const cardContainer = document.querySelector(".product-grid");
  const viewTriggerButtons = document.querySelectorAll(
    "[data-display-trigger]"
  );
  const storageKey = "selectedView";

  const swapTriggerActiveClass = (target) => {
    viewTriggerButtons.forEach((button) => button.classList.remove("active"));
    target.classList.add("active");
    sessionStorage.setItem(
      storageKey,
      target.getAttribute("data-display-trigger")
    );
  };

  const swapView = (target) => {
    cardContainer.dataset.view = target.getAttribute("data-display-trigger");
  };

  const handleTriggerClick = (e, target) => {
    e.preventDefault();
    swapTriggerActiveClass(target);
    swapView(target);
  };

  const addEventListeners = () => {
    viewTriggerButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        handleTriggerClick(e, button);
      });
    });
  };

  const restoreSelectedView = () => {
    const selectedView = sessionStorage.getItem(storageKey);
    if (selectedView) {
      const selectedButton = [...viewTriggerButtons].find(
        (button) => button.getAttribute("data-display-trigger") === selectedView
      );
      if (selectedButton) {
        swapTriggerActiveClass(selectedButton);
        swapView(selectedButton);
      }
    }
  };

  addEventListeners();
  restoreSelectedView();
});
